import apiService from '@/util/request.js';
import smpConfig from '@/util/smp_config';
import moment from 'moment';

const getCampaignCapacity = function ({ commit }) {
  let params = {
    locationId: smpConfig.contextConfig.locationId,
    appType: 'CAMPAIGN'
  };
  return apiService.get('/capacity/default', { params })
    .then((res) => {
      let ninetyDays = moment().add(93, 'days');
      return apiService.get(`/capacity/capacities/${res.data}/available-timeslots`, { params: { to: ninetyDays.toISOString(false) } })
        .then((res) => {
          commit('SET_TIMESLOTS', res.data);
          return res.data;
        });
    });
};

export default {
  getCampaignCapacity
}
